import { Navigate } from "react-router-dom";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { isAdmin } from "../../features/auth/lib/roles";

export default function AdminRoute({ children }) {
  const { user } = useAuth();

  if (!isAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
